/* eslint-disable react/require-default-props */
import { Box, Typography } from '@mui/material';
import React from 'react';
import useCountdown from './hooks';

export const greyBoxStyle = {
  border: 1,
  borderColor: 'divider',
  backgroundColor: 'background.default',
  borderRadius: 1.5,
  padding: 2,
};

const ExpiredNotice = () => (
  <div className="bg-warning text-white p-2 rounded">
    <p>Please select a future date and time.</p>
  </div>
);

const TimerDot = () => (
  <Box className="d-flex flex-column" sx={{ px: 1.25, py: 2 }}>
    <Box
      className="d-inline-block"
      sx={{
        mb: 0.5,
        width: 4,
        height: 4,
        backgroundColor: 'primary.dark',
        borderRadius: 7,
      }}
    />
    <Box
      className="d-inline-block"
      sx={{
        width: 4,
        height: 4,
        backgroundColor: 'primary.dark',
        borderRadius: 7,
      }}
    />
  </Box>
);

interface DateTimeDisplayProps {
  value: number;
  type: string;
  isDanger?: boolean;
}

const DateTimeDisplay = ({ value, type, isDanger = false }:DateTimeDisplayProps) => (
  <div className="d-flex flex-column">
    <div className="d-flex align-items-center">
      <Box sx={[greyBoxStyle, { mb: 1 }]} className="d-inline-block">
        <Typography variant="h5" sx={{ color: 'text.primary' }}>
          {value}
        </Typography>
      </Box>
      { type !== 'Seconds' && <TimerDot />}

    </div>
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {type}
    </Typography>
  </div>
);

interface CountDownProps {
  days:number,
  hours:number,
  minutes:number,
  seconds:number
}

const ShowCounter = ({
  days, hours, minutes, seconds,
}:CountDownProps) => (
  <div className="d-flex align-items-center">
    <DateTimeDisplay value={days} type="Days" />
    <DateTimeDisplay value={hours} type="Hours" />
    <DateTimeDisplay value={minutes} type="Mins" />
    <DateTimeDisplay value={seconds} type="Seconds" />
  </div>
);

const CountdownTimer = ({ targetDate }:any) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return null;
  }
  return (
    <ShowCounter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
    />
  );
};

export default CountdownTimer;
